import { /* domMax */ domAnimation } from 'framer-motion'
export default domAnimation